module.exports = "<div class=\"item\">\n    <div class=\"row text-center text-large text-strong\">\n        <div class=\"col\" translate>\n            CHART_BOOKING_RESOURCES\n        </div>\n    </div>\n\n    <div class=\"chart-no-data\" ng-if=\"$ctrl.bookings.length == 0\" translate>\n        CHART_SERVICES_NO_DATA\n    </div>\n\n    <div id=\"chart-booking-resources-hs\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/chart-booking-resources/chart-booking-resources.html
// module id = 816
// module chunks = 0